import * as Immutable from "immutable";
import { DEFAULT_AXIS_CONFIG, DEFAULT_AXIS_TYPE } from "views/logic/aggregationbuilder/visualizations/XYVisualization";
import { DEFAULT_INTERPOLATION } from "views/Constants";
import VisualizationConfig from "./VisualizationConfig";
export default class AreaVisualizationConfig extends VisualizationConfig {
  constructor(interpolation, axisType = DEFAULT_AXIS_TYPE, axisConfig = DEFAULT_AXIS_CONFIG) {
    super();
    this._value = { interpolation, axisType, axisConfig };
  }
  get interpolation() {
    return this._value.interpolation;
  }
  get axisType() {
    return this._value.axisType;
  }
  get axisConfig() {
    return this._value.axisConfig;
  }
  toBuilder() {
    return new Builder(Immutable.Map(this._value));
  }
  static create(interpolation, axisType = DEFAULT_AXIS_TYPE, axisConfig = DEFAULT_AXIS_CONFIG) {
    return new AreaVisualizationConfig(interpolation, axisType, axisConfig);
  }
  static empty() {
    return AreaVisualizationConfig.create(DEFAULT_INTERPOLATION);
  }
  toJSON() {
    const { interpolation, axisType, axisConfig } = this._value;
    return {
      interpolation,
      axis_type: axisType,
      axis_config: axisConfig
    };
  }
  static fromJSON(_type, value) {
    var _a, _b, _c;
    return AreaVisualizationConfig.create(
      (_a = value == null ? void 0 : value.interpolation) != null ? _a : DEFAULT_INTERPOLATION,
      (_b = value == null ? void 0 : value.axis_type) != null ? _b : DEFAULT_AXIS_TYPE,
      (_c = value == null ? void 0 : value.axis_config) != null ? _c : DEFAULT_AXIS_CONFIG
    );
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  interpolation(value) {
    return new Builder(this.value.set("interpolation", value));
  }
  axisConfig(value) {
    return new Builder(this.value.set("axisConfig", value));
  }
  build() {
    const { interpolation, axisType, axisConfig } = this.value.toObject();
    return new AreaVisualizationConfig(interpolation, axisType, axisConfig);
  }
}
